import { render, staticRenderFns } from "./customSpin.vue?vue&type=template&id=006f6c3c&scoped=true"
import script from "./customSpin.vue?vue&type=script&lang=js"
export * from "./customSpin.vue?vue&type=script&lang=js"
import style0 from "./customSpin.vue?vue&type=style&index=0&id=006f6c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f6c3c",
  null
  
)

export default component.exports